var map = {
	"./pic-1.jpg": 821,
	"./pic-2.jpg": 822,
	"./pic-3.jpg": 823,
	"./pic-4.jpg": 824,
	"./pic-5.jpg": 825,
	"./pic-6.jpg": 826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 820;